"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var ModaBuildYourSofa = __importStar(require("./O_ModaBuildYourSofa"));
var ProductCardGrid = __importStar(require("./O_ProductCardGrid"));
var DrawerWithTitle = __importStar(require("./O_DrawerWithTitle"));
/** Entire Add Items drawer */
var Component = function (p) {
    return (Preact.h(DrawerWithTitle.Component, { platform: p.platform, portrait: p.portrait, open: p.open, sx: p.sx, paddingTop: p.paddingTop, onClose: p.onClose, title: 'Furnish your space' },
        Preact.h(Box_1.default, { marginY: "16px" },
            p.includeModularSofaCta ? (Preact.h(Box_1.default, { sx: { paddingBottom: '20px' } },
                Preact.h(ModaBuildYourSofa.Component, { onGetStartedClick: p.onModularSofaStart, imageUrl: p.modularSofaImageUrl, sx: { height: '157px' }, loading: p.loading }))) : null,
            Preact.h(ProductCardGrid.Component, { products: p.products, onProductAddClick: p.onProductAdd, loading: p.loading, loadingProductId: p.loadingProductId }))));
};
exports.Component = Component;
